// STUDIO-PC-QUICKADD-SLIDE-SYNC-1 · PC 보조 콘솔 · 지난 상품 슬라이드 상태 표시 (Studio 조작 결과 · 읽기 전용).
import React from 'react';
import { Images } from 'lucide-react';
import { pastListOf } from '@/lib/testLiveShare';

const MODE = { once: '한 번 보여주기', loop: '계속 보여주기' };

export const PastSlideStatus = ({ ctx }) => {
  const ps = ctx?.past_slide;
  const list = pastListOf(ctx);
  const on = ps && ps.mode !== 'off';
  const playing = on && ps.playing && list.length > 0;
  const cur = playing ? list[(ps.index || 0) % list.length] : null;
  return (
    <div className="p-2 rounded-lg border border-black/10 dark:border-white/10 bg-black/[0.02] dark:bg-white/[0.02]"
         data-testid="console-past-slide" data-mode={ps?.mode || 'off'} data-playing={playing ? '1' : '0'}>
      <div className="flex items-center gap-1.5">
        <Images size={13} className="text-[#FF3B30]" />
        <span className="text-xs font-black">지난 상품 슬라이드</span>
        <span className={`ml-auto text-[10px] font-black px-1.5 py-0.5 rounded-full ${on ? 'bg-[#30D158]/15 text-[#1F8F3E]' : 'bg-gray-200 text-gray-500 dark:bg-white/10'}`}
              data-testid="console-past-slide-state">
          {on ? `ON · ${MODE[ps.mode]}` : 'OFF'}
        </span>
      </div>
      <p className="mt-1 text-[11px] text-gray-600 dark:text-gray-300 truncate" data-testid="console-past-slide-current">
        {cur ? `표시 중 ${((ps.index || 0) % list.length) + 1}/${list.length} · ${cur.name}`
          : on ? `정지 · 지난 상품 ${list.length}개` : `사용 안 함 · 지난 상품 ${list.length}개`}
      </p>
      <p className="mt-0.5 text-[10px] text-gray-500 dark:text-gray-400">Studio(모바일·PC)에서 조작한 상태가 표시돼요.</p>
    </div>
  );
};

export default PastSlideStatus;
